import React from 'react';
import { Card } from './ui/card';
import { Heart, MapPin, BookOpen } from 'lucide-react';
import { authorInfo } from '../mock/data';

const About = () => {
  const highlights = [
    {
      icon: <Heart className="text-rose-500" size={24} />,
      title: "Romance Sáfico",
      description: "Apaixonada por histórias de amor entre mulheres"
    },
    {
      icon: <BookOpen className="text-sage-600" size={24} />,
      title: "Fantasia Urbana",
      description: "Vampiros, lobisomens e bruxas nunca são demais"
    },
    {
      icon: <MapPin className="text-sage-500" size={24} />,
      title: "Florianópolis",
      description: "Do MS para SC, levando histórias pelo Brasil"
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-sage-800 mb-6">
            Sobre Mim
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-rose-400 to-sage-400 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Author photo and bio */}
          <div className="order-2 md:order-1">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-rose-200 to-sage-200 rounded-2xl transform rotate-6"></div>
              <img
                src={authorInfo.image}
                alt="Luisa Landre"
                className="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl border-4 border-white object-cover aspect-square"
              />
            </div>
          </div>

          <div className="order-1 md:order-2 space-y-6">
            <p className="text-lg text-sage-700 leading-relaxed">
              {authorInfo.bio}
            </p>
            
            <div className="bg-gradient-to-br from-rose-50 to-sage-50 p-6 rounded-xl border border-sage-200">
              <h3 className="text-xl font-semibold text-sage-800 mb-4">Em seus livros você encontra</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <span className="text-xl">🏳️‍🌈</span>
                  <span className="text-sage-700">Protagonismo LGBT+</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xl">💕</span>
                  <span className="text-sage-700">Romance aconchegante</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xl">😎</span>
                  <span className="text-sage-700">Pitadas de comédia</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xl">💚</span>
                  <span className="text-sage-700">Referências nacionais</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Highlights grid */}
        <div className="mt-20 grid sm:grid-cols-3 gap-6">
          {highlights.map((item, index) => (
            <Card key={index} className="p-6 text-center hover:shadow-lg transition-all duration-300 border-sage-200 bg-gradient-to-br from-white to-sage-50">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-white rounded-full shadow-md">
                  {item.icon}
                </div>
              </div>
              <h3 className="text-lg font-semibold text-sage-800 mb-2">
                {item.title}
              </h3>
              <p className="text-sage-600 text-sm">
                {item.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;